export default __webpack_public_path__ + "static/media/discounts-fixed-precent-off-new-items-image.88f2a261.svg";